import { CLOSING_STATUS } from "constants/financialClosing";
import { useGetFinancialClosingQuery } from "store/apis/financialClosing";
import { Period } from "./FinancialClosing";

type ClosingPeriodWithVersionProps = {
  entityId: string;
  financialClosingId: string;
  startDate: string;
  endDate: string;
};

export const ClosingPeriodWithVersion = ({
  entityId,
  financialClosingId,
  startDate,
  endDate,
}: ClosingPeriodWithVersionProps) => {
  const { data } = useGetFinancialClosingQuery(
    { entityId, financialClosingId },
    { skip: !entityId || !financialClosingId }
  );

  const version = data?.closing_card_details.version ?? 1;
  const status = data?.closing_card_details.status;
  const isVersioned = version > 1 || status === CLOSING_STATUS.AMENDED;

  return (
    <>
      <Period start_date={startDate} end_date={endDate} />
      {isVersioned && ` (V${version})`}
    </>
  );
};
